// extracted by mini-css-extract-plugin
module.exports = {"correctCategoryBtn":"view-correct-part-button_correctCategoryBtn__MW9oL","success_btn":"view-correct-part-button_success_btn__WEIwA"};